import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagCategoryTechnology = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4.34668,
			y: 3.81641,
			width: 10.3955,
			height: 10.3955,
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.28223,
			y: 6.75,
			width: 4.52496,
			height: 4.52496,
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.54199 3.66763V1.30078",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.54199 16.5739V14.207",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4365 3.66763V1.30078",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4365 16.5739V14.207",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7572 6.98828L17.124 6.98828",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.85483 6.98828L4.22168 6.98828",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7572 10.8828L17.124 10.8828",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.85483 10.8828L4.22168 10.8828",
			stroke: "#1D1D1D",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTagCategoryTechnology;
